// extracted by mini-css-extract-plugin
export var content = "_cv-3";
export var list = "_cv-4";
export var settingsContent = "_cv-7";
export var settingsPanel = "_cv-8";
export var state = "_cv-6";
export var triggerBadge = "_cv-2";
export var triggerButton = "_cv-1";
export var triggerShell = "_cv-0";
export var unreadDot = "_cv-5";